import {applyMiddleware, combineReducers, createStore} from "redux";
import {combineEpics, createEpicMiddleware} from "redux-observable";
import {RecepcionDocumentalInternetReducer} from "./reducers";
import * as ReduxThunk from "redux-thunk";
import {logger} from "redux-logger";
import {composeWithDevTools} from "redux-devtools-extension";
import {consultarSolicitudEpic, consultarTiposSolicitudEpic} from "./modules/busquedaSolicitud/epics";
import {enviarDocumentosEpic} from "./modules/cargaDocumental/epics";
import {consultarKeyCaptchaEpic} from "./modules/seguridad/epics";
import {consultarCodigoGTMEpic} from "./modules/consultarCodigoGTM/epics";

const rootEpic = combineEpics(
  consultarKeyCaptchaEpic,
  consultarSolicitudEpic,
  consultarTiposSolicitudEpic,
  enviarDocumentosEpic,
  consultarCodigoGTMEpic
);

const epicMiddleware = createEpicMiddleware();

export default function configureStore() {

  const store = createStore(
    combineReducers({
      recDocInternet: RecepcionDocumentalInternetReducer
    }),
    composeWithDevTools(applyMiddleware(ReduxThunk.default, epicMiddleware, logger)),
  );

  epicMiddleware.run(rootEpic);

  return store;
}
